var map = {
	"./dev-lab.webp": 44,
	"./gopro.webp": 45,
	"./placeholder.webp": 19,
	"./puzzle-game.webp": 46,
	"./video-editor.webp": 47,
	"./watch_parties.webp": 48,
	"./webpage.webp": 49
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 43;